import { Directive, Input, HostListener } from '@angular/core';
@Directive({
  standalone: false, 
  selector: '[appPreventClick]'
})
export class PreventClickDirective
{
  @Input() public preventTime = 500;

  @HostListener('click', ['$event']) public clickEvent(event): void
  {
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() =>
    {
      event.srcElement.removeAttribute('disabled');
    }, this.preventTime);
  }
}
